module.exports = __webpack_public_path__ + "static/media/home_bag.9b14e301.png";